import React from 'react';
import { Navigate, Link as LinkRouter } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import style from '../../pages/signin/SignIn.module.css';

// service 
import { useRecover } from './SendRecovery.services';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Laser Application
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SendRecovery() {

  const { logged, noAuth, sendRecovery, reset } = useRecover()

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    sendRecovery(data.get('email'));
  };

  return (
    logged
      ? <Navigate to="/admin" />
      : <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="sm">
          <CssBaseline />
          <Box sx={{
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            {noAuth !== null && noAuth === false
              ? <Alert variant="outlined" severity="warning">Correo inválido</Alert>
              : null
            }
          </Box>

          <Box
            sx={{
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 3,
              paddingTop: 0,
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            <Box sx={{
              borderBottom: "1px solid #E8E8E8",
              alignItems: "center",
              display: 'flex',
              flexDirection: 'column',
              mb: 2,
              pb: 1,
            }}>
              <img className={style.logo2} src='../laser.png' />
              <Typography component="h2" variant='h5'>
                Restablecer Contraseña
              </Typography>
            </Box>
            <Typography variant="body1">
              Ingrese su correo electrónico para buscar su cuenta y enviar un código de recuperación.
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                sx={{ width: 300 }}
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={reset}
              />
              <Box sx={{ display: "flex", justifyContent: "center", gap: 8 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Buscar
                </Button>

                <LinkRouter to="/login" style={{ textDecoration: 'none' }}>
                  <Button fullWidth variant="outlined" sx={{ mt: 3, mb: 2 }} >
                    Regresar
                  </Button>
                </LinkRouter>
              </Box>
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      </ThemeProvider>
  );
}
